(function() {
  // Parse URL params
  var params = new URLSearchParams(window.location.search);
  var productTitle = params.get('product') || '';
  var returnTo = params.get('return_to') || '';

  // Stash in sessionStorage so we survive the post-submit reload
  if (productTitle) {
    try {
      sessionStorage.setItem('ci_product_title', productTitle);
      sessionStorage.setItem('ci_return_to', returnTo);
    } catch (e) {}
  }

  // Restore from sessionStorage if URL has no params (post-submit reload)
  if (!productTitle) {
    try {
      productTitle = sessionStorage.getItem('ci_product_title') || '';
      returnTo = sessionStorage.getItem('ci_return_to') || '';
    } catch (e) {}
  }

  // Populate the return_to hidden input so Shopify redirects server-side
  if (returnTo) {
    var returnInput = document.getElementById('ci-return-to');
    if (returnInput) {
      returnInput.value = returnTo;
    }
  }

  // Populate the "Inquiring about:" display
  if (productTitle) {
    var display = document.getElementById('ci-product-display');
    var nameEl = document.getElementById('ci-product-name');
    if (display && nameEl) {
      nameEl.textContent = productTitle;
      display.style.display = '';
    }
    var subjectInput = document.getElementById('ci-subject');
    if (subjectInput) {
      subjectInput.value = 'Custom Inquiry: ' + productTitle;
    }
  }

  // On form submit: prepend product info to message body
  var form = document.getElementById('custom-inquiry-form');
  if (form) {
    form.addEventListener('submit', function() {
      var body = document.getElementById('ci-message');
      if (productTitle && body && body.value.indexOf('Product Inquired About') === -1) {
        var productUrl = returnTo ? (window.location.origin + returnTo) : '';
        body.value = '--- Product Inquired About ---\n' + productTitle +
                     (productUrl ? '\n\nProduct URL: ' + productUrl : '') +
                     '\n\n--- Customer Message ---\n' + body.value;
      }
    });
  }

  // Backup JS redirect (in case Shopify's return_to doesn't fire for some reason)
  if (document.body.dataset.ciPosted === 'true' || (document.querySelector('.custom-inquiry-page') && document.querySelector('.custom-inquiry-page').dataset.ciPosted === 'true')) {
    try {
      var target = sessionStorage.getItem('ci_return_to');
      sessionStorage.removeItem('ci_product_title');
      sessionStorage.removeItem('ci_return_to');
      if (target) {
        window.location.replace(target);
      }
    } catch (e) {}
  }
})();